
import React, {useEffect } from "react";
import { useUser } from "../context/LoginDetail";
import { Navigate } from "react-router-dom";
export default function ProtectedRoute({ children }) {
  const { user, setUser } = useUser();
  const token = localStorage.getItem("authToken");

  // Optional: restore user from localStorage/session on refresh
  // Example: if you store user info in localStorage
  useEffect(() => {
    if (token && !user) {
      const savedUser = JSON.parse(localStorage.getItem("userData"));
      if (savedUser) setUser(savedUser);
    }
  }, [token, user, setUser]);

  if (!token) {
    return <Navigate to="/" replace />;
  }

  // User might still be null temporarily; allow rendering children
  return children;
}

